import { styled } from "@mui/material";

export const StyledRequestTypeFlag = styled("div")(({ theme }) => ({
    display: `inline-flex`,
    alignItems: `center`,
    justifyContent: `center`,
    borderRadius: `2px`,
    marginRight: `8px`,
}));
